import React from "react";
import {Card, Collapse, Col,Row} from "antd";


const Panel = Collapse.Panel;


const HeaderBanner = () => {
  const callback = (key) => {
    console.log(key);
  };

  return (
      <Row justify="center" style={{marginBottom:100}}>
         {/* <Col lg={6}>
              <div className="title-header wpb_column vc_column_container col-sm-4">
                  <div className="vc_column-inner"><div className="wpb_wrapper"><h1 style={{ "font-size": "48px", "-webkit-text-align": "left", "text-align": "left", "font-family": "Open Sans", "font-weight": "700", "font-style": "normal" }} className="vc_custom_heading vc_custom_1591985196321">Make practice fun for your students</h1>
                  <div className="wpb_text_column wpb_content_element  vc_custom_1591985323363">
                      <div className="wpb_wrapper">
                          <div className="page" title="Page 1">
                              <div className="section">
                                  <div className="layoutArea">
                                      <div className="column">
                                          <p><span style={{ "color": "#000000" }}><strong style={{ "font-size": "1rem" }}>Free tools for teachers to assign curriculum aligned Math and Science quizzes. </strong><p>Available for teachers in CBSE &amp; ICSE Class 6- 10. </p><span style={{ "color": "#295784" }} /></span></p>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
              </div>
              </div>
         </Col>
         <Col lg={6}>
         <img  src="https://quiznext.in/wp-content/uploads/2020/06/Gamidication3.png" className="vc_single_image-img attachment-full" alt srcSet="https://quiznext.in/wp-content/uploads/2020/06/Gamidication3.png 2704w, https://quiznext.in/wp-content/uploads/2020/06/Gamidication3-300x180.png 300w, https://quiznext.in/wp-content/uploads/2020/06/Gamidication3-768x460.png 768w, https://quiznext.in/wp-content/uploads/2020/06/Gamidication3-1024x613.png 1024w" sizes="(max-width: 2704px) 100vw, 2704px" />
         </Col> */}
    
    </Row>
  );
};

export default HeaderBanner;
